// 答复框是否可编辑状态
var disabledList = {
  weight: false,
  height: false,
  age: false,
  brand: false,
  brandSize: false,
  bustAndCup: false,
};

// 选择器是否已创建的状态
var displayedList = {
  weight: false,
  height: false,
  age: false,
  brand: false,
  brandSize: false,
  bustAndCup: false,
};

var currentValueList = {
  weight: { value: 0, unit: "" },
  height: { value: 0, unit: "" },
  age: 22,
  brand: "",
  brandSize: "",
  bust: "",
  cup: "",
  recommendSize: {
    size: "",
    percent: "84%",
  },
  email: "",
};

var localSavedData = window.localStorage.getItem("oglmove.size.selected");
if (localSavedData) {
  currentValueList = JSON.parse(localSavedData);
  var size = currentValueList.recommendSize.size;
  if (size && size != "") {
    // setEntryTitle(size);
    updateSelectedValue(localSavedData);
  }
}

function setEntryTitle(size) {
  var titleA = document.querySelector(".guide-entry .title");
  titleA.textContent = "";
  titleA.style.textDecoration = "none";

  var spanSize = titleA.querySelector(".span-size");
  if (!spanSize) {
    spanSize = document.createElement("span");
    spanSize.classList.add("span-size");
    titleA.appendChild(spanSize);
  }
  spanSize.style.fontWeight = 800;
  spanSize.textContent = "SIZE: " + size;

  var spanRecom = titleA.querySelector(".span-recom");
  if (!spanRecom) {
    spanRecom = document.createElement("span");
    spanRecom.classList.add("span-recom");
    titleA.appendChild(spanRecom);
  }
  spanRecom.style.fontWeight = 100;
  spanRecom.textContent = " is Your Recommendation.";
}

function restoreSavedData() {
  //createHeightDiv();
  if (localSavedData) {
    var containerElement = window.localStorage.getItem("oglmove.size.selector");
    if (containerElement) {
      var whatSizeModal = document.getElementById("what-my-size-modal");
      var modalContent = whatSizeModal.querySelector(".modal-content");
      modalContent.innerHTML = containerElement;
      var emailInput = modalContent.querySelector("#email-input");
      emailInput && (emailInput.value = currentValueList.email);
      restoreEventListener(whatSizeModal);
      var stepsDiv = document.querySelectorAll(
        ".bs-stepper-header *:not([style*='display: none']):not(button):not(span)"
      );
      var steps = parseInt((stepsDiv.length + 1) / 2);
      updateSteps(steps);
    } else {
      if (document.querySelector('#what-my-size-container #height-select-container')) {
        return
      }
      createHeightDiv();
      updateSteps(1);
    }
  } else {
    if (document.querySelector('#what-my-size-container #height-select-container')) {
      return
    }
    createHeightDiv();
    updateSteps(1);
  }
}

function restoreEventListener(whatSizeModal) {
  whatSizeModal
    .querySelector(".close-button")
    .addEventListener("click", closeModal);
  addRecommendSizeBtnsListener();
}

var translateYList = {
  height: 0,
  weight: 0,
  age: 0,
  brand: 0,
  brandSize: 0,
  bustAndCup: 0,
};

var submitUrl = "https://ecowrd.com/webhook/recommend-size";
var submitEmail = "https://ecowrd.com/webhook/email-report";
var requestBody = {
  customer: {
    height: {
      value: 175,
      unit: "cm",
    },
    weight: {
      value: 42,
      unit: "kg",
    },
    age: 32,
    brand: "",
    brandSize: "",
    bust: "",
    cup: "",
    uid: window.uid || "",
    id: window.userId || "",
  },
  product: {
    id: window.productId,
  },
};

// 观察器的配置（需要观察哪些属性）
var size_selector_config = {
  attributes: true,
  attributeOldValue: true,
  attributeFilter: ["style"],
};

var currentObserverNode;
// 当观察到变化时执行的回调函数
var callback = function (mutationsList, size_selector_observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === "attributes") {
      const style = currentObserverNode.style.opacity;
      // 你可以在这里添加你需要的代码来响应透明度的变化
      if (style == 0) {
        currentObserverNode.style.display = "none";
        size_selector_observer.disconnect();
      }
    }
  }
};

// 创建一个观察器实例并传入回调函数
var size_selector_observer = new MutationObserver(callback);

// 以后，你可以停止观察
// size_selector_observer.disconnect();

// 创建身高选择器
function createHeightDiv() {
  var subSizeContainer;
  if (!displayedList.height) {
    const whatSizeContainner = document.getElementById(
      "what-my-size-container"
    );
    if (!whatSizeContainner) {
      console.warn("缺少容器元素，请添加id为what-my-size-container的容器元素");
      return false;
    }

    var mainTitleText = "How tall are you?";
    var subTitleText = "This helps your profile take shape.";
    var rulerContainerId = "height-ruler";
    var btnGroupName = "height-uom";

    subSizeContainer = document.createElement("div");
    subSizeContainer.classList.add("size-sub-container");
    subSizeContainer.setAttribute("id", "height-select-container");
    whatSizeContainner.appendChild(subSizeContainer);

    createMainTitle(subSizeContainer, mainTitleText);
    createSubTitle(subSizeContainer, subTitleText);
    createRuleContainer(subSizeContainer, rulerContainerId);
    drawInchRule(rulerContainerId);
    createRuleBtns(subSizeContainer, btnGroupName, ["in", "cm"], "in");
    addBtnsListener(btnGroupName, rulerContainerId);
    displayedList.height = true;
  } else {
    subSizeContainer = document.getElementById("height-select-container");
  }
  return subSizeContainer;
}

// 创建体重选择器
function createWeightDiv() {
  var subSizeContainer;
  if (!displayedList.weight) {
    const whatSizeContainner = document.getElementById(
      "what-my-size-container"
    );
    if (!whatSizeContainner) {
      console.warn("缺少容器元素，请添加id为what-my-size-container的容器元素");
      return false;
    }

    var mainTitleText = "What do you weigh?";
    var subTitleText = "It's just one factor in understanding fit.";
    var rulerContainerId = "weight-ruler";
    var btnGroupName = "weight-uom";

    subSizeContainer = document.createElement("div");
    subSizeContainer.classList.add("size-sub-container");
    subSizeContainer.setAttribute("id", "weight-select-container");
    whatSizeContainner.appendChild(subSizeContainer);

    createMainTitle(subSizeContainer, mainTitleText);
    createSubTitle(subSizeContainer, subTitleText);
    createRuleContainer(subSizeContainer, rulerContainerId);
    drwanLbRule(rulerContainerId);
    createRuleBtns(subSizeContainer, btnGroupName, ["lb", "kg"], "lb");
    addBtnsListener(btnGroupName, rulerContainerId);
    displayedList.weight = true;
  } else {
    subSizeContainer = document.getElementById("weight-select-container");
  }

  return subSizeContainer;
}

// 创建年龄选择器
function createAgeSelector() {
  var subSizeContainer;
  if (!displayedList.age) {
    const whatSizeContainner = document.getElementById(
      "what-my-size-container"
    );
    if (!whatSizeContainner) {
      console.warn("缺少容器元素，请添加id为what-my-size-container的容器元素");
      return false;
    }

    var mainTitleText = "What's your age?";
    var subTitleText = "Age can impact body shape and how some brands fit.";
    subSizeContainer = document.createElement("div");
    subSizeContainer.classList.add("size-sub-container");
    subSizeContainer.setAttribute("id", "age-select-container");
    whatSizeContainner.appendChild(subSizeContainer);

    createMainTitle(subSizeContainer, mainTitleText);
    createSubTitle(subSizeContainer, subTitleText);
    createAgeBtns(subSizeContainer);
    displayedList.age = true;
  } else {
    subSizeContainer = document.getElementById("age-select-container");
  }

  return subSizeContainer;
}

// 创建品牌选择器
function createBrandSelector() {
  var subSizeContainer;
  if (!displayedList.brand) {
    const whatSizeContainner = document.getElementById(
      "what-my-size-container"
    );
    if (!whatSizeContainner) {
      console.warn("缺少容器元素，请添加id为what-my-size-container的容器元素");
      return false;
    }

    var mainTitleText = "What brand fits great?";
    var subTitleText = "This informs how related items fit in other brands.";
    subSizeContainer = document.createElement("div");
    subSizeContainer.classList.add("size-sub-container");
    subSizeContainer.setAttribute("id", "brand-select-container");
    whatSizeContainner.appendChild(subSizeContainer);

    createMainTitle(subSizeContainer, mainTitleText);
    createSubTitle(subSizeContainer, subTitleText);
    createBrandBtns(subSizeContainer);
    displayedList.brand = true;
  } else {
    subSizeContainer = document.getElementById("brand-select-container");
  }

  return subSizeContainer;
}

// 创建品牌尺码选择器
function createBrandSizeSelector() {
  var subSizeContainer;
  const whatSizeContainner = document.getElementById("what-my-size-container");
  if (!whatSizeContainner) {
    console.warn("缺少容器元素，请添加id为what-my-size-container的容器元素");
    return false;
  }

  var mainTitleText = "What size is your " + currentValueList.brand + "?";
  var subTitleText = "We know sizes vary across brands and styles.";
  var curr = document.getElementById("brand-size-select-container");
  subSizeContainer = document.createElement("div");
  subSizeContainer.classList.add("size-sub-container");
  subSizeContainer.setAttribute("id", "brand-size-select-container");
  if (curr) {
    whatSizeContainner.replaceChild(subSizeContainer, curr);
  } else {
    whatSizeContainner.appendChild(subSizeContainer);
  }
  createMainTitle(subSizeContainer, mainTitleText);
  createSubTitle(subSizeContainer, subTitleText);
  createBrandSizeBtns(subSizeContainer);
  return subSizeContainer;
}

// 创建胸围罩杯选择器
function createBustAndCupSelector() {
  var subSizeContainer;
  if (!displayedList.bustAndCup) {
    const whatSizeContainner = document.getElementById(
      "what-my-size-container"
    );
    if (!whatSizeContainner) {
      console.warn("缺少容器元素，请添加id为what-my-size-container的容器元素");
      return false;
    }

    var mainTitleText = "What's your bra size?";
    //var subTitleText = "xxxxxx";
    subSizeContainer = document.createElement("div");
    subSizeContainer.classList.add("size-sub-container");
    subSizeContainer.setAttribute("id", "bust-cup-select-container");
    whatSizeContainner.appendChild(subSizeContainer);

    createMainTitle(subSizeContainer, mainTitleText);
    //createSubTitle(subSizeContainer, subTitleText);
    createBustAndCupBtns(subSizeContainer);
    displayedList.bustAndCup = true;
  } else {
    subSizeContainer = document.getElementById("bust-cup-select-container");
  }

  return subSizeContainer;
}

// 创建选择器的主标题
function createMainTitle(parentElement, text) {
  var mainTitle = document.createElement("h2");
  mainTitle.classList.add("main-title");
  mainTitle.textContent = text;
  parentElement.appendChild(mainTitle);
}

// 创建选择器的副标题
function createSubTitle(parentElement, text) {
  var subTitle = document.createElement("div");
  subTitle.classList.add("sub-title");
  subTitle.textContent = text;
  parentElement.append(subTitle);
}

// 创建刻度尺容器
function createRuleContainer(parentElement, containnerId) {
  var container = document.createElement("div");
  container.classList.add("ruler-wrap", "bounce-in");
  container.setAttribute("id", containnerId);
  parentElement.appendChild(container);
}

// 创建刻度尺切换按钮
function createRuleBtns(parentElement, btnGroupName, uomArr, defaultUom) {
  var ruleBtnDiv = document.createElement("div");
  ruleBtnDiv.classList.add("ruler-btn");
  var ruleBtnGroup = document.createElement("div");
  ruleBtnGroup.classList.add("btn-group", "btn-group-lg");
  ruleBtnGroup.setAttribute("role", "group");
  for (let uom of uomArr) {
    var btnRadio = document.createElement("input");
    btnRadio.classList.add("btn-check");
    btnRadio.setAttribute("type", "radio");
    btnRadio.setAttribute("name", btnGroupName);
    btnRadio.setAttribute("id", uom);
    btnRadio.setAttribute("autocomplete", "off");
    if (defaultUom == uom) {
      btnRadio.setAttribute("checked", true);
    }
    var btnLabel = document.createElement("label");
    btnLabel.classList.add("btn", "btn-outline-info", "ruler-btn");
    btnLabel.setAttribute("for", uom);
    btnLabel.textContent = uom;
    ruleBtnGroup.appendChild(btnRadio);
    ruleBtnGroup.appendChild(btnLabel);
  }

  ruleBtnDiv.appendChild(ruleBtnGroup);
  parentElement.appendChild(ruleBtnDiv);
}

// 为刻度尺切换按钮添加点击事件监听器
function addBtnsListener(btnGroupName, rulerContainerId) {
  const rulerBtns = document.querySelectorAll(
    "input[name=" + btnGroupName + "]"
  );
  rulerBtns.forEach((element) => {
    element.addEventListener("click", (event) => {
      switch (event.target.id) {
        case "lb":
          drwanLbRule(rulerContainerId);
          break;
        case "cm":
          drawnCmRule(rulerContainerId);
          break;
        case "kg":
          drawnKgRule(rulerContainerId);
          break;
        case "in":
          drawInchRule(rulerContainerId);
          break;
      }
    });
  });
}

// 显示刻度尺上的值
function displayFloatText(containerId, value, uom) {
  const prarentElement = document.getElementById(containerId);
  var floatDiv = prarentElement.querySelector('.float-seize-seat-div .rule-float-div')
  var firstSpan = floatDiv.querySelector(".first");
  if (!firstSpan) {
    firstSpan = document.createElement("span");
    firstSpan.classList.add("first");
  }

  var secondSpan = floatDiv.querySelector(".second");
  if (!secondSpan) {
    secondSpan = document.createElement("span");
    secondSpan.classList.add("second");
  }

  var removeThirdAndFour = false;
  var thirdSpan = floatDiv.querySelector(".third");
  if (!thirdSpan) {
    thirdSpan = document.createElement("span");
    thirdSpan.classList.add("third");
  } else {
    removeThirdAndFour = true;
  }

  var fourthSpan = floatDiv.querySelector(".fourth");
  if (!fourthSpan) {
    fourthSpan = document.createElement("span");
    fourthSpan.classList.add("fourth");
  } else {
    removeThirdAndFour = true;
  }

  if (uom == "in") {
    if (value / 10 > 1) {
      firstSpan.textContent = Math.floor(value / 10);
      secondSpan.textContent = " ft ";
      thirdSpan.textContent = value % 10;
      fourthSpan.textContent = " in";
      floatDiv.appendChild(firstSpan);
      floatDiv.appendChild(secondSpan);
      floatDiv.appendChild(thirdSpan);
      floatDiv.appendChild(fourthSpan);
    } else {
      firstSpan.textContent = value + " ";
      secondSpan.textContent = uom;
      if (removeThirdAndFour) {
        floatDiv.removeChild(thirdSpan);
        floatDiv.removeChild(fourthSpan);
      }
      floatDiv.appendChild(firstSpan);
      floatDiv.appendChild(secondSpan);
    }
  } else {
    firstSpan.textContent = value + " ";
    secondSpan.textContent = uom;
    if (removeThirdAndFour) {
      floatDiv.removeChild(thirdSpan);
      floatDiv.removeChild(fourthSpan);
    }
    floatDiv.appendChild(firstSpan);
    floatDiv.appendChild(secondSpan);
  }
}

// 绘制inch选择刻度尺
function drawInchRule(containerId) {
  //调用刻度尺方法
  ruler.initPlugin({
    el: containerId, //容器id
    uom: "in",
    startValue: 54,
    background: "#ffffff",
    markColor: "#DDC9B3",
    maxScale: 100,
    isConstant: true,
    success: function (res) {
      if (!disabledList.height && currentValueList.height.value != res) {
        var inch =
          res / 10 > 1
            ? Math.floor(res / 10) + "'" + (res % 10) + '"'
            : res + '"';
        var ftch =
          res / 10 > 1
            ? Math.floor(res / 10) + " ft " + (res % 10) + " in"
            : res + " in";
        displayFloatText(containerId, res, "in");
        addPopDiv(containerId, "I am " + inch, "height");
        currentValueList.height.value = inch;
        currentValueList.height.unit = "inch";
        window.localStorage.setItem(
          "oglmove.size.selected",
          JSON.stringify(currentValueList)
        );
      }
    },
  });
}

// 绘制cm选择刻度尺
function drawnCmRule(containerId) {
  //调用刻度尺方法
  ruler.initPlugin({
    el: containerId, //容器id
    uom: "cm",
    startValue: 165,
    maxScale: 250,
    background: "#ffffff",
    markColor: "#DDC9B3",
    isConstant: true,
    success: function (res) {
      displayFloatText(containerId, res, "cm");
      if (!disabledList.height && currentValueList.height.value != res) {
        addPopDiv(containerId, "I am " + res + " cm", "height");
        currentValueList.height.value = parseFloat(res.toFixed(2));
        currentValueList.height.unit = "cm";
        window.localStorage.setItem(
          "oglmove.size.selected",
          JSON.stringify(currentValueList)
        );
      }
    },
  });
}

// 绘制lb选择刻度尺
function drwanLbRule(containerId) {
  //调用刻度尺方法
  ruler.initPlugin({
    el: containerId, //容器id
    uom: "lb",
    startValue: 165,
    maxScale: 300,
    background: "#ffffff",
    markColor: "#DDC9B3",
    isConstant: true,
    success: function (res) {
      displayFloatText(containerId, res, "lb");
      if (!disabledList.weight && currentValueList.weight.value != res) {
        currentValueList.weight.value = parseFloat(res.toFixed(2));
        currentValueList.weight.unit = "lb";
        window.localStorage.setItem(
          "oglmove.size.selected",
          JSON.stringify(currentValueList)
        );
      }
      addPopDiv(containerId, "I weigh " + res + " lb", "weight");
    },
  });
}

// 绘制kg选择刻度尺
function drawnKgRule(containerId) {
  //调用刻度尺方法
  ruler.initPlugin({
    el: containerId, //容器id
    uom: "kg",
    startValue: 45,
    background: "#ffffff",
    markColor: "#DDC9B3",
    isConstant: true,
    success: function (res) {
      displayFloatText(containerId, res, "kg");
      if (!disabledList.weight && currentValueList.weight.value != res) {
        addPopDiv(containerId, "I weigh " + res + " kg", "weight");
        currentValueList.weight.value = parseFloat(res.toFixed(2));
        currentValueList.weight.unit = "kg";
        window.localStorage.setItem(
          "oglmove.size.selected",
          JSON.stringify(currentValueList)
        );
      }
    },
  });
}

// 滚动到指定元素位置
function scrollToElement(anchorId) {
  // 查找元素
  const anchorElement = document.getElementById(anchorId);
  if (anchorElement) {
    // 使用scrollIntoView方法居中显示
    console.log('scroll-size')
    anchorElement.scrollIntoView(true, {
      behavior: "smooth",
      block: "start",
    });
  }
}
// 添加确认用户所选刻度值的汽包组件
var count = 0;
function addPopDiv(rulerContainerId, text, type) {
  var weightDiv, ageDiv, brandDiv, brandSizeDiv, bustAndCupDiv;
  const containner = document.getElementById(rulerContainerId);
  const parentElement = containner.parentElement;
  var seizeASeatDiv = parentElement.nextElementSibling;
  var popDiv, textDiv, entryBtn, entryBtnImg, editBtn, editBtnImg;

  if (!seizeASeatDiv || !seizeASeatDiv.classList.contains("seize-a-seat")) {
    count++;
    seizeASeatDiv = document.createElement("div");
    seizeASeatDiv.classList.add("seize-a-seat");
    if (count != 1) {
      seizeASeatDiv.style.transform = parentElement.style.transform;
    }
    parentElement.parentElement.append(seizeASeatDiv);

    popDiv = document.createElement("div");
    popDiv.classList.add("pop-range");
    popDiv.setAttribute("id", "pop-div-" + count);
    seizeASeatDiv.appendChild(popDiv);

    textDiv = document.createElement("div");
    textDiv.classList.add("response-text");
    popDiv.appendChild(textDiv);

    entryBtn = document.createElement("button");
    entryBtn.classList.add(
      "btn",
      "btn-outline-info",
      "response-btn",
      "entry-btn"
    );
    entryBtn.type = "link";
    entryBtn.setAttribute("sort", count);
    popDiv.appendChild(entryBtn);

    entryBtnImg = document.createElement("img");
    entryBtnImg.classList.add("pop-btn-img");
    entryBtnImg.setAttribute("src", entryImgPath);
    entryBtn.appendChild(entryBtnImg);

    editBtn = document.createElement("button");
    editBtn.classList.add(
      "btn",
      "btn-outline-info",
      "response-btn",
      "edit-btn"
    );
    editBtn.setAttribute("sort", count);
    editBtn.type = "link";

    editBtnImg = document.createElement("img");
    editBtnImg.setAttribute("src", editImgPath);
    editBtn.appendChild(editBtnImg);
    editBtn.style.borderColor = "#DDC9B3";
    editBtn.style.backgroundColor = "#DDC9B3";
    editBtn.style.display = "none";
    popDiv.appendChild(editBtn);

    entryBtn.addEventListener("click", (event) => {
      event.preventDefault();
      popDiv.style.backgroundColor = "#DDC9B3";
      entryBtn.style.backgroundColor = "#DDC9B3";
      entryBtn.style.borderColor = "#DDC9B3";
      textDiv.style.backgroundColor = "#DDC9B3";
      editBtnImg.style.backgroundColor = "#DDC9B3";

      popDiv.classList.add("pop-range-light");
      popDiv.classList.remove("pop-range");
      // 隐藏
      // 获取父级组件的高度便于上下移动
      var computedStyle = window.getComputedStyle(containner.previousSibling);
      var computedStyleHeight = 0;

      if (computedStyle) {
        computedStyleHeight = parseInt(
          computedStyle.getPropertyValue("height"),
          10
        );
      }

      var curPopComStyle = window.getComputedStyle(seizeASeatDiv);
      var curPopComHeight = parseInt(
        curPopComStyle.getPropertyValue("height"),
        10
      );

      // 开始观察已配置的目标节点
      currentObserverNode = parentElement;
      size_selector_observer.observe(parentElement, size_selector_config);

      var distanceFromTop = computedStyleHeight - curPopComHeight * count;
      parentElement.style.transform = "translateY(-" + distanceFromTop + "px)";
      parentElement.style.opacity = 0;
      var popMoveDistance =
        computedStyleHeight - (curPopComHeight * (count - 1) + 20);
      seizeASeatDiv.style.transform = "translateY(-" + popMoveDistance + "px)";

      switch (type) {
        case "height":
          disabledList.height = true;
          weightDiv = createWeightDiv();
          weightDiv.style.transform = "translateY(-" + distanceFromTop + "px)";
          break;
        case "weight":
          disabledList.weight = true;
          ageDiv = createAgeSelector();
          ageDiv.style.transform = "translateY(-" + distanceFromTop + "px)";
          break;
        case "age":
          disabledList.age = true;
          brandDiv = createBrandSelector();
          brandDiv.style.transform = "translateY(-" + distanceFromTop + "px)";
          break;
        case "brand":
          disabledList.brand = true;
          if (currentValueList.brand && currentValueList.brand != "") {
            brandSizeDiv = createBrandSizeSelector();
            brandSizeDiv.style.transform =
              "translateY(-" + distanceFromTop + "px)";
          } else {
            disabledList.brandSize = true;
            count = count + 2;
            submitInfoToBack(parentElement.parentElement);
          }
          break;
        case "brandSize":
          disabledList.brandSize = true;
          if (isDress) {
            bustAndCupDiv = createBustAndCupSelector();
            bustAndCupDiv.style.transform =
              "translateY(-" + distanceFromTop + "px)";
          } else {
            disabledList.bustAndCup = true;
            submitInfoToBack(parentElement.parentElement);
          }
          break;
        case "bustAndCup":
          disabledList.bustAndCup = true;
          submitInfoToBack(parentElement.parentElement);
          break;
      }
      entryBtn.style.display = "none";
      var editBtn = popDiv.querySelector(".edit-btn");
      editBtn.style.display = "inline-block";
      editBtn.style.backgroundColor = "#DDC9B3";
      editBtn.style.boderColor = "#DDC9B3";
      try {
        var sort = parseInt(entryBtn.getAttribute("sort"));
        updateSteps(sort + 1);
      } catch (error) {
        console.log(error);
      }
    });

    editBtn.addEventListener("click", (event) => {
      event.preventDefault();
      popDiv.style.backgroundColor = "#764B38";
      editBtn.style.backgroundColor = "#764B38";
      editBtn.style.borderColor = "#764B38";
      textDiv.style.backgroundColor = "#764B38";
      editBtnImg.style.backgroundColor = "#764B38";
      popDiv.classList.add("pop-range");
      popDiv.classList.remove("pop-range-light");
      seizeASeatDiv.style.transform = "translateY(0)";
      parentElement.style.opacity = 1;
      parentElement.style.display = "block";
      switch (type) {
        case "height":
          disabledList.height = false;
          weightDiv.style.transform = "translateY(0)";
          break;
        case "weight":
          disabledList.weight = false;
          ageDiv.style.transform = "translateY(0)";
          break;
        case "age":
          disabledList.age = false;
          brandDiv.style.transform = "translateY(0)";
          break;
        case "brand":
          disabledList.brand = false;
          brandSizeDiv.style.transform = "translateY(0)";
          break;
        case "brandSize":
          disabledList.brandSize = false;
          bustAndCupDiv.style.transform = "translateY(0)";
          break;
        case "bustAndCup":
          disabledList.bustAndCup = false;
          break;
      }
      editBtn.style.display = "none";
      var entryBtn = popDiv.querySelector(".entry-btn");
      entryBtn.style.display = "inline-block";
      entryBtn.style.backgroundColor = "#764B38";
      entryBtn.style.borderColor = "#764B38";
      try {
        var sort = parseInt(editBtn.getAttribute("sort"));
        updateSteps(sort);
      } catch (error) {
        console.log(error);
      }
    });
  } else {
    popDiv =
      seizeASeatDiv.querySelector(".pop-range") ||
      seizeASeatDiv.querySelector(".pop-range-light");
    textDiv = popDiv.querySelector(".response-text");
    entryBtn = popDiv.querySelector(".entry-btn");
    editBtn = popDiv.querySelector(".edit-btn");
  }
  textDiv.textContent = text;
  scrollToElement("pop-div-" + (count - 1));
}

// 创建年龄滑块选择器
function createAgeRange(parentElement) {
  var ageSelectorContainer = document.createElement("div");
  ageSelectorContainer.classList.add("size-sub-container");
  ageSelectorContainer.id = "age-selector-container";

  var ageRangeDiv = document.createElement("div");
  ageRangeDiv.classList.add("select-age-range");
  ageRangeDiv.id = "select-age-div";
  ageSelectorContainer.appendChild(ageRangeDiv);
  parentElement.appendChild(ageSelectorContainer);

  var min = 16;
  var max = 90;
  var startValue = 26;
  var ageRange = document.createElement("input");
  ageRange.classList.add("form-range", "form-range-info");
  ageRange.setAttribute("min", min);
  ageRange.setAttribute("max", max);
  ageRange.setAttribute("value", startValue);
  ageRange.setAttribute("steps", 1);
  ageRange.setAttribute("type", "range");

  var tooltipSpan = document.createElement("span");
  tooltipSpan.classList.add("display-value-span");
  tooltipSpan.textContent = startValue + " years old";
  ageRange.addEventListener("mouseup", (event) => {
    tooltipSpan.textContent = event.target.value + " years old";
    currentValueList.age = parseInt(event.target.value);
    window.localStorage.setItem(
      "oglmove.size.selected",
      JSON.stringify(currentValueList)
    );
    addPopDiv(
      ageSelectorContainer.id,
      "I am " + tooltipSpan.textContent,
      "age"
    );
  });

  ageRange.addEventListener("touchend", (event) => {
    tooltipSpan.textContent = event.target.value + " years old";
    currentValueList.age = parseInt(event.target.value);
    window.localStorage.setItem(
      "oglmove.size.selected",
      JSON.stringify(currentValueList)
    );
    addPopDiv(
      ageSelectorContainer.id,
      "I am " + tooltipSpan.textContent,
      "age"
    );
  });

  ageRange.addEventListener("input", (event) => {
    tooltipSpan.textContent = event.target.value + " years old";
  });

  ageRange.id = "age-select-range";
  ageRangeDiv.appendChild(ageRange);
  ageRangeDiv.appendChild(tooltipSpan);
}

// 创建年龄区间按钮选择器
function createAgeBtns(parentElement) {
  var ageBtnsDiv = document.createElement("div");
  ageBtnsDiv.classList.add("select-age-btns");
  ageBtnsDiv.id = "age-wrap";
  var textArr = ["16-18", "19-24", "25-34", "35-44", "45-54", "55-64", "65+"];

  for (let index = 0; index < textArr.length; index++) {
    var text = textArr[index];
    var ageBtn = document.createElement("input");
    ageBtn.classList.add("btn-check");
    ageBtn.setAttribute("type", "radio");
    ageBtn.setAttribute("name", "age-btn");
    ageBtn.setAttribute("id", "option" + index);
    ageBtn.setAttribute("autocomplete", "off");

    var ageBtnLabel = document.createElement("label");
    ageBtnLabel.classList.add("btn", "btn-light");
    ageBtnLabel.setAttribute("for", "option" + index);
    ageBtnLabel.textContent = text;
    ageBtnsDiv.appendChild(ageBtn);
    ageBtnsDiv.appendChild(ageBtnLabel);
  }

  parentElement.appendChild(ageBtnsDiv);
  setTimeout(() => {
    addPopDiv(ageBtnsDiv.id, "Rather not say", "age");
  }, 500);
  var ageBtns = ageBtnsDiv.getElementsByTagName("input");
  for (btn of ageBtns) {
    btn.addEventListener("click", (event) => {
      var id = event.target.id;
      const number = id.match(/\d+/g);
      var selectedValue = textArr[number[0]];
      currentValueList.age = selectedValue;
      window.localStorage.setItem(
        "oglmove.size.selected",
        JSON.stringify(currentValueList)
      );
      var ageRange;
      var text;
      if (selectedValue.indexOf("-") > 0) {
        ageRange = selectedValue.split("-");
        text = "My age is between " + ageRange[0] + " and " + ageRange[1];
      } else {
        text = "My age is " + selectedValue;
      }
      addPopDiv(ageBtnsDiv.id, text, "age");
    });
  }
}

// 创建品牌按钮选择器
function createBrandBtns(parentElement) {
  var brandBtnsDiv = document.createElement("div");
  brandBtnsDiv.classList.add("select-brand-btns");
  brandBtnsDiv.id = "select-brand-container";
  var imageArr = [
    americanEagleImgPath,
    jcrewImgPath,
    madewellImgPath,
    aritziaImgPath,
  ];
  var brandArr = ["American Eagle", "J.Crew", "Madewell", "Aritzia"];

  for (let index = 0; index < imageArr.length; index++) {
    var image = imageArr[index];
    var brandBtn = document.createElement("input");
    brandBtn.classList.add("btn-check");
    brandBtn.setAttribute("type", "radio");
    brandBtn.setAttribute("name", "age-btn");
    brandBtn.setAttribute("id", "brand-option" + index);
    brandBtn.setAttribute("autocomplete", "off");

    var brandBtnLabel = document.createElement("label");
    brandBtnLabel.classList.add("btn", "btn-light", "brand-btn-label");
    brandBtnLabel.setAttribute("for", "brand-option" + index);

    var btnImg = document.createElement("img");
    btnImg.classList.add("brand-btn-img");
    btnImg.src = image;
    brandBtnLabel.appendChild(btnImg);
    brandBtnsDiv.appendChild(brandBtn);
    brandBtnsDiv.appendChild(brandBtnLabel);
  }

  parentElement.appendChild(brandBtnsDiv);
  setTimeout(() => {
    addPopDiv(brandBtnsDiv.id, "Rather not say", "brand");
  }, 500);
  var brandBtns = brandBtnsDiv.getElementsByTagName("input");
  for (btn of brandBtns) {
    btn.addEventListener("click", (event) => {
      var id = event.target.id;
      const number = id.match(/\d+/g);
      var selectedValue = brandArr[number[0]];
      currentValueList.brand = selectedValue;
      window.localStorage.setItem(
        "oglmove.size.selected",
        JSON.stringify(currentValueList)
      );
      addPopDiv(
        brandBtnsDiv.id,
        "My " + selectedValue + " top fits great",
        "brand"
      );
    });
  }
}

var sizeArr = ["2XS", "XS", "S", "M", "L", "XL", "2XL"];
var brandSizeList = {
  "American Eagle": [
    "(00)",
    "(0-2)",
    "(4-6)",
    "(8-10)",
    "(12-14)",
    "(16-18)",
    "(20-22)",
  ],
  "J.Crew": ["(00)", "(0-2)", "(4-6)", "(8-10)", "(12-14)", "(16)", "(18)"],
  Madewell: ["(000)", "(00-0)", "(2-4)", "(6-8)", "(10-12)", "(14-16)", "(18)"],
  Aritzia: ["(00)", "(0)", "(2-4)", "(6-8)", "(10-12)", "(14-16)", "(18)"],
  OGL: ["(00)", "(0)", "(2-4)", "(6-8)", "(10-12)", "(14-16)", "(18)"],
};
// 创建品牌尺码按钮选择器
function createBrandSizeBtns(parentElement) {
  var brandSizeBtnsDiv = document.createElement("div");
  brandSizeBtnsDiv.classList.add("select-brand-size-btns");
  brandSizeBtnsDiv.id = "select-brand-size-container";
  var brandSize = brandSizeList[currentValueList.brand];
  for (let index = 0; index < sizeArr.length; index++) {
    var size = sizeArr[index];
    var americanSize = brandSize[index];
    var sizeBtn = document.createElement("input");
    sizeBtn.classList.add("btn-check");
    sizeBtn.setAttribute("type", "radio");
    sizeBtn.setAttribute("name", "brand-size-btn");
    sizeBtn.setAttribute("id", "brand-size-option" + index);
    sizeBtn.setAttribute("autocomplete", "off");

    var brandBtnLabel = document.createElement("label");
    brandBtnLabel.classList.add("btn", "btn-light", "brand-size-btn-label");
    brandBtnLabel.setAttribute("for", "brand-size-option" + index);
    var sizeSpan = document.createElement("span");
    sizeSpan.textContent = size;
    brandBtnLabel.appendChild(sizeSpan);
    if (brandSize) {
      var br = document.createElement("br");
      brandBtnLabel.appendChild(br);
      var aSizeSpan = document.createElement("span");
      aSizeSpan.textContent = americanSize;
      brandBtnLabel.appendChild(aSizeSpan);
    }
    brandSizeBtnsDiv.appendChild(sizeBtn);
    brandSizeBtnsDiv.appendChild(brandBtnLabel);
  }

  parentElement.appendChild(brandSizeBtnsDiv);
  setTimeout(() => {
    addPopDiv(brandSizeBtnsDiv.id, "Rather not say", "brandSize");
  }, 500);
  var brandBtns = brandSizeBtnsDiv.getElementsByTagName("input");
  for (btn of brandBtns) {
    btn.addEventListener("click", (event) => {
      var id = event.target.id;
      const number = id.match(/\d+/g);
      var selectedValue = sizeArr[number[0]];
      currentValueList.brandSize = selectedValue;
      window.localStorage.setItem(
        "oglmove.size.selected",
        JSON.stringify(currentValueList)
      );
      addPopDiv(
        brandSizeBtnsDiv.id,
        "I wear size " + selectedValue,
        "brandSize"
      );
    });
  }
}

// 创建胸围罩杯选择按钮
function createBustAndCupBtns(parentElement) {
  var bustCupBtnsContainer = document.createElement("div");
  bustCupBtnsContainer.classList.add("select-bust-cup-container");
  bustCupBtnsContainer.id = "select-bust-cup-container";
  parentElement.appendChild(bustCupBtnsContainer);

  var bustArr = [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54];
  var cupArr = [
    "A",
    "A½",
    "B",
    "B½",
    "C",
    "C½",
    "D",
    "D½",
    "E",
    "E½",
    "F",
    "G",
    "H",
  ];

  var bustCupBtnsDiv = document.createElement("div");
  bustCupBtnsDiv.classList.add("bust-cup-select-btns");
  bustCupBtnsContainer.appendChild(bustCupBtnsDiv);

  var bustBtnsDiv = document.createElement("table");
  bustBtnsDiv.classList.add("bust-btn-group");
  bustBtnsDiv.setAttribute("role", "group");
  bustCupBtnsDiv.appendChild(bustBtnsDiv);
  var titleRow = document.createElement("tr");
  titleRow.classList.add("table-row");
  var bustTitleBtn = document.createElement("td");
  bustTitleBtn.classList.add("btn", "btn-outline-info");
  bustTitleBtn.textContent = "Bust";
  bustTitleBtn.setAttribute("colspan", 3);
  titleRow.appendChild(bustTitleBtn);
  bustBtnsDiv.appendChild(titleRow);

  for (let i = 0; i <= bustArr.length / 3; i++) {
    var tableRow = document.createElement("tr");
    tableRow.classList.add("table-row");
    bustBtnsDiv.appendChild(tableRow);

    for (let j = 0; j < 3; j++) {
      if (bustArr[i * 3 + j]) {
        var tableCell = document.createElement("td");
        tableCell.style.display = "table-cell";
        tableCell.classList.add("table-cell");
        tableCell.style.borderTop = "0px";
        if (j == 1 || j == 2) {
          tableCell.style.borderLeft = "0px";
        }
        var input = document.createElement("input");
        input.type = "radio";
        input.classList.add("btn-check");
        input.name = "bust-btn";
        input.id = "bust-btn" + (i * 3 + j);
        input.setAttribute("autocomplete", "off");

        var label = document.createElement("label");
        label.classList.add("btn", "btn-outline-info", "bust-btn");
        label.setAttribute("for", input.id);
        label.textContent = bustArr[i * 3 + j];
        tableCell.appendChild(input);
        tableCell.appendChild(label);
        tableRow.appendChild(tableCell);
      }
    }
  }

  var cupBtnsDiv = document.createElement("table");
  cupBtnsDiv.classList.add("bust-btn-group");
  cupBtnsDiv.setAttribute("role", "group");
  bustCupBtnsDiv.appendChild(cupBtnsDiv);
  var cupTitleRow = document.createElement("tr");
  cupTitleRow.classList.add("table-row");
  var cupTitleBtn = document.createElement("td");
  cupTitleBtn.classList.add("btn", "btn-outline-info");
  cupTitleBtn.textContent = "Cup";
  cupTitleBtn.setAttribute("colspan", 3);
  cupTitleRow.appendChild(cupTitleBtn);
  cupBtnsDiv.appendChild(cupTitleRow);
  for (let i = 0; i <= cupArr.length / 3; i++) {
    var tableRow = document.createElement("tr");
    tableRow.classList.add("table-row");
    cupBtnsDiv.appendChild(tableRow);

    for (let j = 0; j < 3; j++) {
      if (cupArr[i * 3 + j]) {
        var tableCell = document.createElement("td");
        tableCell.style.display = "table-cell";
        tableCell.classList.add("table-cell");
        tableCell.style.borderTop = "0px";
        if (j == 1 || j == 2) {
          tableCell.style.borderLeft = "0px";
        }
        var input = document.createElement("input");
        input.type = "radio";
        input.classList.add("btn-check");
        input.name = "cup-btn";
        input.id = "cup-btn" + (i * 3 + j);
        input.setAttribute("autocomplete", "off");

        var label = document.createElement("label");
        label.classList.add("btn", "btn-outline-info", "cup-btn");
        label.setAttribute("for", input.id);
        label.textContent = cupArr[i * 3 + j];
        tableCell.appendChild(input);
        tableCell.appendChild(label);
        tableRow.appendChild(tableCell);
      }
    }
  }
  bustCupBtnsContainer.appendChild(bustCupBtnsDiv);
  var brandBtns = bustCupBtnsDiv.getElementsByTagName("input");
  for (btn of brandBtns) {
    btn.addEventListener("click", (event) => {
      var id = event.target.id;
      const number = id.match(/\d+/g);
      var strArr = id.split("-");
      var name = strArr[0];
      if (name == "cup") {
        var selectedValue = cupArr[number[0]];
        currentValueList.cup = selectedValue;
      } else {
        var selectedValue = bustArr[number[0]];
        currentValueList.bust = selectedValue;
      }

      window.localStorage.setItem(
        "oglmove.size.selected",
        JSON.stringify(currentValueList)
      );
      var text = "";
      if (currentValueList.bust && currentValueList.cup) {
        text =
          "The Bra size I usually wear is " +
          currentValueList.bust +
          currentValueList.cup;
      } else if (currentValueList.bust && !currentValueList.cup) {
        text =
          "The selected bust is " +
          currentValueList.bust +
          ", please continue selecting cup sizes";
      } else if (!currentValueList.bust && currentValueList.cup) {
        text =
          "The selected cup is " +
          currentValueList.cup +
          ", please continue selecting bust";
      }
      addPopDiv(bustCupBtnsContainer.id, text, "bustAndCup");
    });
  }
}

function submitInfoToBack(parentElement) {
  requestBody.customer.age = currentValueList.age;
  requestBody.customer.height.value = currentValueList.height.value;
  requestBody.customer.height.unit = currentValueList.height.unit;
  requestBody.customer.weight.value = currentValueList.weight.value;
  requestBody.customer.weight.unit = currentValueList.weight.unit;
  requestBody.customer.brand = currentValueList.brand;
  requestBody.customer.brandSize = currentValueList.brandSize;
  requestBody.customer.bust = currentValueList.bust;
  requestBody.customer.cup = currentValueList.cup;
  requestBody.product.id = productId;
  requestBody.customer.id = userId;
  ajax.post(
    submitUrl,
    requestBody,
    (respose) => {
      //console.log(respose);
      if (respose.includes("available")) {
        respose = currentValueList.brandSize
          ? currentValueList.brandSize
          : "No suitable size.";
      }
      createRecommendSize(parentElement, respose);
    },
    (error) => {
      if (error) {
        console.log("server error: ", error);
        respose = currentValueList.brandSize;
        createRecommendSize(parentElement, respose);
      }
    }
  );
}

function createRecommendSize(parentElement, size) {
  var modal = document.getElementById("what-my-size-modal");
  var recommendSizeWrap = document.createElement("div");
  var id = "recommend-size-container";
  recommendSizeWrap.id = id;
  recommendSizeWrap.classList.add(id);
  createMainTitle(recommendSizeWrap, "Your best fit.");

  // 获取模态框内容区域
  var modalContentDiv = modal.querySelector(".modal-content");
  modalContentDiv.removeChild(parentElement);
  modalContentDiv.appendChild(recommendSizeWrap);

  var productImg = document.createElement("img");
  productImg.classList.add("product-img");
  productImg.setAttribute("src", productMainImage);
  recommendSizeWrap.appendChild(productImg);

  var recommendSizeDiv = document.createElement("div");
  recommendSizeDiv.classList.add("recommend-size");
  var mainRecommendDiv = document.createElement("div");
  mainRecommendDiv.classList.add("main-recommend");
  var mainRadioDiv = document.createElement("div");
  mainRadioDiv.classList.add("radio");
  // var mainRadioInput = document.createElement("input");
  // mainRadioInput.classList.add("form-check-input");
  // mainRadioInput.type = "radio";
  // mainRadioInput.name = "main-radio";
  // mainRadioInput.id = "main-radio";
  // mainRadioInput.setAttribute("checked", true);
  // mainRadioDiv.appendChild(mainRadioInput);

  var americanSize = brandSizeList["OGL"][sizeArr.indexOf(size)];
  var mainRadioLabel = document.createElement("label");
  mainRadioLabel.classList.add("form-check-label");
  mainRadioLabel.setAttribute("for", "main-radio");
  mainRadioLabel.textContent = size + " ";
  var labelSpan = document.createElement("span");
  labelSpan.classList.add("label-span");
  labelSpan.textContent = americanSize;
  labelSpan.style.fontSize = "16px";
  mainRadioLabel.appendChild(labelSpan);
  mainRadioDiv.appendChild(mainRadioLabel);
  mainRecommendDiv.appendChild(mainRadioDiv);

  var mainProgressDiv = document.createElement("div");
  mainProgressDiv.classList.add("progress");
  mainProgressDiv.setAttribute("role", "progressbar");
  var mainProgress = document.createElement("div");
  mainProgress.classList.add("progress-bar");
  var mainPercent = getRandomSecure(80, 90);
  var percentText = mainPercent + "%";
  if (size.includes('No suitable size')) {
    percentText = '0%';
  }
  mainProgress.style.width = percentText;
  mainProgress.textContent = percentText;
  mainProgressDiv.appendChild(mainProgress);
  mainRecommendDiv.appendChild(mainProgressDiv);
  recommendSizeDiv.appendChild(mainRecommendDiv);
  recommendSizeWrap.appendChild(recommendSizeDiv);

  var descriptionDiv = document.createElement("div");
  descriptionDiv.classList.add("description");
  var secondBlock = document.createElement("p");
  secondBlock.classList.add("second-block");
  //var mainPercent = getRandomSecure(80, 90);
  var text =
    "Based on the purchases of thousands of similar shoppers, there is an " +
    mainProgress.textContent +
    " chance that you will be happy with size " +
    size +
    " " +
    (americanSize ? americanSize : "") +
    ".";
  if (size.includes('No suitable size')) {
    text = 'It looks like some information might be missing. Could you please fill in all the details so we can recommend the perfect size for you? This will help ensure the best fit!';
  }
  secondBlock.textContent = text;
  descriptionDiv.appendChild(secondBlock);
  recommendSizeWrap.appendChild(descriptionDiv);

  var recommendBtnsDiv = document.createElement("div");
  recommendBtnsDiv.classList.add("recommend-btns");

  var form = document.createElement("form");
  form.classList.add("needs-validation");
  form.setAttribute("novalidate", true);
  form.id = "submit-email-form";
  if (!userId || userId == "") {
    var formGroup = document.createElement("div");
    formGroup.classList.add("form-group");
    var emailLabel = document.createElement("label");
    emailLabel.setAttribute("for", "email-input");
    emailLabel.textContent =
      "Please leave your Email to save your personal size profile";
    formGroup.appendChild(emailLabel);

    var emailInput = document.createElement("input");
    emailInput.type = "email";
    emailInput.classList.add("form-control");
    emailInput.id = "email-input";
    emailInput.required = true;
    if (currentValueList.email && currentValueList.email != "") {
      emailInput.value = currentValueList.email;
    }
    emailInput.setAttribute("placeholder", "Enter your Email address");
    formGroup.appendChild(emailInput);

    var feedback = document.createElement("div");
    feedback.classList.add("invalid-feedback");
    feedback.textContent = "Please provide a valid Email.";
    formGroup.appendChild(feedback);
    form.appendChild(formGroup);
  }
  var shoppingBtnDiv = document.createElement("div");
  shoppingBtnDiv.classList.add("btn-container");
  var shoppingBtn = document.createElement("button");
  shoppingBtn.type = "submit";
  shoppingBtn.classList.add("btn", "t4s-btn", "t4s-btn-base", "t4s-btn-color-dark");
  shoppingBtn.textContent = "Save and Continue";
  shoppingBtnDiv.appendChild(shoppingBtn);
  // var btnImg = document.createElement("img");
  // btnImg.classList.add("shopping-btn-img");
  // btnImg.src = entryImgPath;
  // shoppingBtn.appendChild(btnImg);
  recommendBtnsDiv.appendChild(shoppingBtnDiv);

  var editBtnDiv = document.createElement("div");
  editBtnDiv.classList.add("btn-container");
  var editBtn = document.createElement("button");
  editBtn.type = "link";
  editBtn.classList.add("btn", "btn-light");
  editBtn.textContent = "Edit Info";

  editBtnDiv.appendChild(editBtn);
  recommendBtnsDiv.appendChild(editBtnDiv);
  form.appendChild(recommendBtnsDiv);
  recommendSizeWrap.appendChild(form);
  currentValueList.recommendSize.size = size;
  currentValueList.recommendSize.percent = mainProgress.textContent;

  addRecommendSizeBtnsListener();
  window.localStorage.setItem(
    "oglmove.size.selected",
    JSON.stringify(currentValueList)
  );
  updateSelectedValue(localSavedData);
}

function addRecommendSizeBtnsListener() {
  var modal = document.getElementById("what-my-size-modal");
  var forms = document.getElementsByClassName("needs-validation");
  // Loop over them and prevent submission
  var validation = Array.prototype.filter.call(forms, function (form) {
    form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        if (form.checkValidity() === false) {
          event.stopPropagation();
        } else {
          setEntryTitle(currentValueList.recommendSize.size);
          var modalContent = modal.querySelector(".modal-content");
          window.localStorage.setItem(
            "oglmove.size.selector",
            modalContent.innerHTML
          );
          console.log(modalContent.innerHTML);
          var email = document.getElementById("email-input")?.value;
          var data = { uid: uid, email: email };
          currentValueList.email = email;
          window.localStorage.setItem(
            "oglmove.size.selected",
            JSON.stringify(currentValueList)
          );
          if (!currentValueList.email || currentValueList.email == "") {
            ajax.post(
              submitEmail,
              data,
              (respose) => {
                console.log("email submit success", respose);
              },
              (error) => {
                if (error) {
                  console.log("server error: ", error);
                }
              }
            );
          }
          closeModal();
        }
        form.classList.add("was-validated");
      },
      false
    );
  });

  var editBtn = modal.querySelector(
    "#recommend-size-container .btn-container .btn-light"
  );
  if (editBtn) {
    editBtn.addEventListener("click", () => {
      count = 0;
      var container = document.createElement("div");
      container.id = "what-my-size-container";
      var recommendSizeWrap = modal.querySelector("#recommend-size-container");
      var modalContentDiv = modal.querySelector(".modal-content");
      modalContentDiv.removeChild(recommendSizeWrap);
      modalContentDiv.appendChild(container);
      displayedList = {
        weight: false,
        height: false,
        age: false,
        brand: false,
        brandSize: false,
        bustAndCup: false,
      };

      disabledList = {
        weight: false,
        height: false,
        age: false,
        brand: false,
        brandSize: false,
        bustAndCup: false,
      };
      createHeightDiv();
      localSavedData = undefined;
      window.localStorage.removeItem("oglmove.size.selector");
      window.localStorage.removeItem("oglmove.size.selected");
      try {
        updateSteps(1);
      } catch (error) {
        console.log(error);
      }
    });
  }
}

// 返回一个安全的随机数，范围为min到max（包括min和max）
function getRandomSecure(min, max) {
  var array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  var randomNum = array[0] / (0xffffffff + 1);
  return Math.floor(randomNum * (max - min + 1) + min);
}
